import { memo, splitProps } from '../helpers.mjs';
import { createRecipe, mergeRecipes } from './create-recipe.mjs';

const textareaSectionFn = /* @__PURE__ */ createRecipe('textarea-section', {}, [])

const textareaSectionVariantMap = {
  "pointerEvents": [
    "none",
    "auto"
  ]
}

const textareaSectionVariantKeys = Object.keys(textareaSectionVariantMap)

export const textareaSection = /* @__PURE__ */ Object.assign(memo(textareaSectionFn.recipeFn), {
  __recipe__: true,
  __name__: 'textareaSection',
  __getCompoundVariantCss__: textareaSectionFn.__getCompoundVariantCss__,
  raw: (props) => props,
  variantKeys: textareaSectionVariantKeys,
  variantMap: textareaSectionVariantMap,
  merge(recipe) {
    return mergeRecipes(this, recipe)
  },
  splitVariantProps(props) {
    return splitProps(props, textareaSectionVariantKeys)
  },
  getVariantProps: textareaSectionFn.getVariantProps,
})